// Kostaja site config. Editable constants used across the site.
export const SITE = {
  name: "Kostaja",
  tagline: "Brand and website studio shaped by commercial judgment",
  description:
    "Kostaja helps businesses become easier to trust, easier to understand, and easier to choose.",
  region: "Ontario, Canada",
  url: "https://kostaja.ca",
  shopUrl: "https://shop.kostaja.ca/",
  bookingUrl: "https://calendly.com/kostaja-info/30min",
  email: "info@kostaja.ca",
  emailHref: "mailto:info@kostaja.ca",
  phoneDisplay: "+1 (819) 650-2168",
  phoneHref: "tel:+18196502168",
  currency: "CAD",
};

// External integration routing helpers.
// If a service has an empty stripePaymentLink, the buy CTA must route to:
//   /contact?service=<slug>
export const BUY_FALLBACK_PATH = "/contact";

// Reserved future-ready routes (architecture stubs only).
// DEV NOTE: Secure auth + role-based access + DB models required before
// any real portal or admin features go live. Do NOT expose data here.
export const RESERVED_ROUTES = [
  "/client-portal",
  "/login",
  "/account",
  "/dashboard",
  "/admin",
];

export const CATEGORIES = [
  { slug: "strategy-and-audits", name: "Strategy and Audits" },
  { slug: "brand-systems", name: "Brand Systems" },
  { slug: "website-systems", name: "Website Systems" },
  { slug: "brand-and-website-packages", name: "Brand and Website Packages" },
  { slug: "local-visibility", name: "Local Visibility" },
  { slug: "content-and-social", name: "Content and Social" },
  { slug: "print-and-sales-materials", name: "Print and Sales Materials" },
  { slug: "digital-product-support", name: "Digital Product Support" },
  { slug: "platform-brand-kits", name: "Platform Brand Kits" },
  { slug: "marketing-support", name: "Marketing Support" },
  { slug: "business-launch-support", name: "Business Launch Support" },
  { slug: "custom-projects", name: "Custom Projects" },
];

export const PRINCIPLES = [
  "Outcomes before methods",
  "Commercial judgment on every project",
  "Plain English",
  "Discipline over decoration",
  "Fixed price where possible",
  "No mystery process",
  "No dead ends",
  "Useful before the first call",
  "Honest portfolio presentation",
  "Practical strategy with strong execution",
];
